import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { FrontDeskRefusal as n } from "@maat/api-booking/types";
//#region src/enums/useTrFrontDeskRefusal.ts
var r = {
	[n.CheckInTooEarly]: "frontDesk.refusal.checkInTooEarly",
	[n.NoShowTooEarly]: "frontDesk.refusal.noShowTooEarly",
	[n.BookingNotConfirmed]: "frontDesk.refusal.bookingNotConfirmed",
	[n.BookingNotCheckedIn]: "frontDesk.refusal.bookingNotCheckedIn"
}, i = (e) => typeof e == "string" && e in r, a = () => {
	let { t: n } = t("booking");
	return e((e) => {
		let t = e?.response?.data?.code;
		return i(t) ? n(r[t]) : void 0;
	}, [n]);
};
//#endregion
export { a as useTrFrontDeskRefusal };
